import { h, Component } from "preact";
import { Link } from "preact-router/match";
import { Text } from "preact-i18n";

import store from "../../store";

import ServiceWrapper from "./serviceWrapper";

export default class aService extends Component {
  render() {
    return (
      <ServiceWrapper {...this.props}>
        <article class="has-widget">
          <p>
            Izjūtiet pa īstam lielisku ātrumu - tādu, pie kura esam pieraduši,
            izmantojot iemīļotos servisus YouTube, Instagram, Netflix, Gmail,
            Bolt Taxi un daudzus citus!
          </p>
          <p>
            DolphNet klientiem ir pieejams mūsdienīgs mākoņhostings, ar kura
            palīdzību jebkurā pasaules vietā mājas lapai var piekļūt maksimāli
            ātri.
          </p>
          <img
            style="max-width: 200px;"
            src="/assets/img/amazon-web-services.svg"
            alt="AWS"
          />
		  <img
            style="max-width: 200px;margin: 15px 25px;"
            src="/assets/img/google-cloud-services.svg"
            alt="AWS"
          />
          <p>
            Pakalpojuma nodrošināšanai tiek izmantotas platformas Amazon Web
            Services (AWS), Google Cloud Platform (GCP) un citas, kuras izmanto
            veiksmīgākie pasaules zīmoli, tādi kā Apple, McDonalds, GoPro,
            Verizon, Spotify, HSBC, Home Depot, Snapchat, HTC, Best Buy,
            Philips, Coca Cola, Domino's, Feedly, ShareThis, Sony Music, Ubisoft
            un The Washington Post.
          </p>
          <h2>Priekšrocības</h2>
          <ul>
            <li>Paātrināta mājas lapas ielāde no jebkuras vietas pasaulē;</li>
            <li>Rezerves kopijas katru dienu;</li>
            <li>Aizsardzība pret hakeru uzbrukumiem;</li>
            <li>Ērta iestatījumu pārvalde hostinga administrēšanas vidē;</li>
            <li>
              Datu centra un infrastruktūras atbilstība GDPR datu aizsardzības
              regulai.
            </li>
          </ul>
        </article>
        <div class="widget plan">
          <h3>
            <span class="from">
              <Text id="cart.from" />
            </span>
            <span class="value">&euro;160</span>
            <span class="term">
              {" "}
              <Text id="cart.year.full" />
            </span>
          </h3>
          <ul class="bullet">
            <li>Bezmaksas pieslēgšana</li>
            <li>Bezmaksas mājas lapas pārcelšana</li>
            <li>10% atlaide, maksājot par 24 mēnešiem</li>
          </ul>
          <div>
            <Link
              href={store.prefix + "/contact?service=hosting&form=true"}
              class="button"
            >
              <Text id="email.widget.list.btn" />
            </Link>
          </div>
        </div>
      </ServiceWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./routes/services/hosting.js